const potrait = 'portrait-primary';

export function isPortraitScreen() {
    const { screen: { orientation: { type = '' } = {} } = {} } = window;
    return type === potrait;
}
